import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

export const Info = styled.div`
  display: flex;
  gap: 13px;
  align-items: center;
  padding-bottom: 4px;
  small {
    margin-top: 2px;
  }

  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    flex-flow: column;
  }

  @media print {
    flex-flow: column;
    gap: 2px;
  }
`;

export const InfoBar = styled.div`
  width: 2px;
  height: 16px;
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae60};

  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    display: none;
  }
`;

export const Flexed = styled.div`
  display: flex;
  flex-flow: column;
`;

export const NormalFlex = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;

  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    flex-flow: column;
    text-align: center;
  }
`;
